/**
 * @generated SignedSource<<449daa4c11c1fae8ff46e4fbf142c05a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSectionMap_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mapHeight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "zoomDefault",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "map",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ParticipativeModule",
              "kind": "LinkedField",
              "name": "participativeModule",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ParticipativeModuleAuthorizations",
                  "kind": "LinkedField",
                  "name": "authorizations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contributionsDisplayAuthorized",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ContributionsMapContributionsMarkersManager_participativeModule"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "VisualizationMap",
          "abstractKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapContextProvider_map"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapBase_map"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageSectionMap",
  "abstractKey": null
};

node.hash = "1338b50539af1b7733843ac4cb8433a6";

module.exports = node;
